import { EmailField } from "../fields/emailField";
import { TelField } from "../fields/telField";
import { UsernameField } from "../fields/usernameField";
import { toggleValidStep } from '../../actions';
import { EVENT_NAME_FIELDS_VALIDATE, EVENT_NAME_STEP_VALIDATE } from "../../helpers/consts";
import { CheckboxField } from "../fields/checkboxField";

export class ContactInformationStep {
    /**
     * Component that handles the contact information step.
     * @constructor
     * @param {Object} options
     * @param {Store} options.store
     * @param {string} options.id - Step id string
     */
    constructor(options) {
        this.store = options.store;
        this.state = this.store.getState();
        this.translations = options.translations;
        this.isValid = false;
        this.id = options.id;
        this.createStep();
        this.update();
        this.store.subscribe(this.update.bind(this));
    }

    createStep() {
        const $fieldSet = document.createElement('div');
        const fieldSetHTML = `
<div class="fieldset">
    <div class="row">
        <div class="col-12 col-sm-12 col-md-6 field form-group col--field--tel"></div>
        <div class="col-12 col-sm-12 col-md-6 field form-group col--field--email"></div>
    </div>
    <div class="row">
        <div class="col-12 col-sm-24 field form-group col--field--username"></div>
    </div>
    <div class="row">
        <div class="col-12 col-sm-24 field form-group col--field--optin"></div>
    </div>
</div>
        `;
        $fieldSet.classList.add('fieldset');
        $fieldSet.innerHTML = fieldSetHTML;

        this.$telField = new TelField({
            store: this.store,
            stepId: this.id,
            id: 'telephone',
            label: __('Telephone number'),
            $context: $fieldSet,
        });

        this.$usernameField = new UsernameField({
            store: this.store,
            stepId: this.id,
            id: 'username',
            label: __('Username'),
            $context: $fieldSet,
            readOnly: true,
            required: false,
            valid: true,
        });

        this.$emailField = new EmailField({
            store: this.store,
            stepId: this.id,
            id: 'email',
            label: __('E-mail address'),
            $context: $fieldSet,
        });

        this.$optinCheckbox = new CheckboxField({
            store: this.store,
            stepId: this.id,
            id: 'marketingOptin',
            label: this.translations.optin_information_allow ? this.translations.optin_information_allow : __('Information consent allow'),
            $context: $fieldSet,
            required: true
        })

        $fieldSet.querySelector('.col--field--tel').appendChild(this.$telField.render());
        $fieldSet.querySelector('.col--field--email').appendChild(this.$emailField.render());
        $fieldSet.querySelector('.col--field--username').appendChild(this.$usernameField.render());
        $fieldSet.querySelector('.col--field--optin').appendChild(this.$optinCheckbox.render());

        $fieldSet.addEventListener(EVENT_NAME_STEP_VALIDATE, this.validateStep.bind(this));
        $fieldSet.addEventListener(EVENT_NAME_FIELDS_VALIDATE, () => {
            this.$telField.validate();
            this.$emailField.validate();
        });

        this.$el = $fieldSet;
    }

    validateStep() {
        this.isValid = this.$telField.valid() && this.$emailField.valid();
        this.store.dispatch(toggleValidStep(this.id, this.isValid));
    }

    render() {
        return this.$el;
    }

    update() {
        const emailFieldValue = this.state.formFields.find(field => field.id === this.$emailField.id );

        if (emailFieldValue && emailFieldValue.value) {
            this.$usernameField.setValue(emailFieldValue.value);
        }
        this.state = this.store.getState();
    }
}

export default ContactInformationStep;
